import React, { useState, useEffect } from "react"
import { makeStyles } from "@material-ui/core/styles"
import FormControl from "@material-ui/core/FormControl"
import FormLabel from "@material-ui/core/FormLabel"
import InputBase from "@material-ui/core/InputBase"
import FormHelperText from "@material-ui/core/FormHelperText"

const useStyles = makeStyles(theme => ({
  root: {
    textAlign: "left",
    width: "100%",
    flexDirection: props => props.horizontal && "row",
    alignItems: props => props.horizontal && "center",
    justifyContent: props => props.horizontal && "space-between",
  },
  inputRoot: {
    borderColor: theme.palette.black.support,
    borderStyle: "solid",
    borderWidth: 1,
    height: theme.spacing(6),
    width: props => props.width && theme.spacing(props.width),
  },
  inputError: {
    borderColor: theme.palette.error.main,
  },
  input: {
    paddingLeft: theme.spacing(2),
    ...theme.typography.body1,
  },
  label: props => ({
    color: props.labelColor
      ? theme.palette[props.labelColor].main
      : theme.palette.black.support,
    marginBottom: props => !props.horizontal && theme.spacing(1),
    marginTop: 0,
    ...theme.typography[props.labelVariant || "button"],
  }),
  labelFocused: props => ({
    color:
      (props.labelColor
        ? theme.palette[props.labelColor].main
        : theme.palette.black.support) + " !important",
  }),
  helperText: {
    color: theme.palette.black.support,
  },
}))

export default props => {
  const classes = useStyles(props)
  const [error, setError] = useState("")
  const [value, setValue] = useState(props.initialValue || "")

  const validations = props.validation
    ? Array.isArray(props.validation)
      ? props.validation
      : [props.validation]
    : []
  const restrictions = props.restriction
    ? Array.isArray(props.restriction)
      ? props.restriction
      : [props.restriction]
    : []

  const validate = uncheckedValue => {
    let errorMessage = ""
    for (let validate of validations) {
      errorMessage = validate(uncheckedValue)
      if (errorMessage) {
        break
      }
    }
    if (error !== errorMessage) {
      setError(errorMessage)
    }
    return !errorMessage
  }

  const restrict = uncheckedValue => {
    for (let restrict of restrictions) {
      const pass = restrict(uncheckedValue)
      if (!pass) {
        return pass
      }
    }
    return true
  }

  useEffect(() => {
    if (props.valid) {
      props.valid(() => validate(value))
    }
  }, [value])

  const handleChange = newValue => {
    if (restrict(newValue)) {
      validate(newValue)
      if (props.onChange) {
        props.onChange(newValue, error)
      }
      setValue(newValue)
    }
  }

  return (
    <FormControl error={!!error} classes={{ root: classes.root }}>
      <FormLabel
        htmlFor={props.id}
        classes={{ root: classes.label, focused: classes.labelFocused }}
      >
        {props.label}
      </FormLabel>
      <InputBase
        value={value}
        onChange={e => {
          handleChange(e.target.value)
        }}
        type={props.type}
        id={props.id}
        aria-describedby={props.id + "-helper-text"}
        classes={{
          root: classes.inputRoot,
          input: classes.input,
          error: classes.inputError,
        }}
      />
      {props.noHelperText ? (
        undefined
      ) : (
        <FormHelperText
          id={props.id + "-helper-text"}
          classes={{ root: classes.helperText }}
        >
          {error}
        </FormHelperText>
      )}
    </FormControl>
  )
}
